import { Component,OnInit, OnChanges } from '@angular/core';
import { Router, Routes,ActivatedRoute  } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'FormView';
  project: any;
  constructor(private activeRoute: ActivatedRoute, private route: Router)
  {
  }

  ngOnInit(): void {
    this.activeRoute.queryParams.subscribe(
      params => {
      
        if(params['id']!=undefined)
        {
          this.project = params['id']
         
          sessionStorage.setItem('project', this.project)   
          this.route.navigate(['ci'])
        }
        else{
          //console.log("params['id']!=undefined")
        }
      },
      error=>{
        console.log("ERROR")
      });
  }
}
